module.exports = __webpack_public_path__ + "img/product-shot_02.68447e4e.jpg";